import { ViewRegion } from "utils/metrics";
import { IGif } from "services/types";
import { dateTimeHR } from "utils/dates";
import { routes } from "routes";
import { TOnPinParams } from "../usePinsGif";

type TAdaptTileProps = {
  gif: IGif;
  onPinGif: (params: TOnPinParams) => void;
  showPlaceholders: boolean;
}

export const adaptTileProps = ({
  gif,
  showPlaceholders,
  onPinGif
}: TAdaptTileProps) => {
  const { id, userName, createDate, urls, tags, type, published, views, duration, gallery, description } = gif;
  const thumbnail = urls.thumbnail || urls.poster;

  return {
    thumbnail,
    imageAlt: `${tags.slice(0, 3).join(", ")} porn ${id} uploaded by ${userName} on ${dateTimeHR(createDate)}`,
    video: type === 1 ? urls.sd : undefined,
    published,
    verified: false,
    link: routes.watch(id),
    views,
    duration,
    gallery: !!gallery,
    description,
    manage: false,
    checked: undefined,
    onCheck: undefined,
    source: ViewRegion.Profile,
    showPinsIcons: showPlaceholders,
    pined: true,
    onPinGif: () => onPinGif({ available: true, gif: gif }),
  };
};

export const reorder = (
  list: IGif[],
  startIndex: number,
  endIndex: number
) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);

  result.splice(endIndex, 0, removed);

  return result;
};
